export default __webpack_public_path__ + "static/media/user-thoughts.0501f499.svg";